import {
    Checkbox, ContextualMenu, DefaultButton, Dropdown, getId,
    Icon, IDragOptions, Modal, PrimaryButton
} from '@fluentui/react';

import { DataUtils } from '../../common/views/DataUtils';
import { NewFeedFilterModel } from '../models/NewFeedModel';
import {
    dropdownStyles, defaultButtonStyles, primaryButtonStyles
} from '../../common/views/DefaultStyles';
import { StyleUtils } from '../../common/views/StyleUtils';
import { Utils } from '../../common/views/Utils';

type NewFeedFilterProps = {
    form: NewFeedFilterModel;
    onValueChange: (field: keyof NewFeedFilterModel, value: any) => void;
    onClose: () => void;
    onSubmit: () => void;
}

export default function NewFeedFilterView({ form, onClose, onValueChange, onSubmit }: NewFeedFilterProps) {
    const _titleId: string = getId('title');
    const _subtitleId: string = getId('subText');
    const _dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    const width2 = Utils.getColumnWidth(2);
    const width6 = Utils.getColumnWidth(6);
    const width10 = Utils.getColumnWidth(10);

    const header = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>New Feed Sort & Filters</b></div>
                <div className={width2 + " right"}>
                    <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    const typePicker = () => {
        return <div className="ms-Grid-row pt-10">
            <Dropdown
                label="Type"
                selectedKey={form.type}
                onChange={(_, v) => onValueChange("type", v?.key || 0)}
                options={DataUtils.getFileTypeOptions()}
                styles={dropdownStyles} />
        </div>;
    }

    const openOnlyCheckbox = () => {
        return <div className="ms-Grid-row pt-15">
            <Checkbox
                label="Open Only?"
                checked={form.isOpen}
                onChange={(_, v) => onValueChange("isOpen", v || false)} />
        </div>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row pv-15">
            <div className={width6 + " pl-0"}>
                <DefaultButton onClick={onClose} styles={defaultButtonStyles}>
                    Cancel
                </DefaultButton>
            </div>
            <div className={width6 + " pr-0"}>
                <PrimaryButton onClick={onSubmit} styles={primaryButtonStyles}>
                    Submit
                </PrimaryButton>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={_titleId}
            subtitleAriaId={_subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <div>
                <div className="popup-header">
                    {header()}
                </div>
                <div id={_subtitleId} className="popup-body ph-20 pv-10">
                    <div className="ms-Grid">
                        {typePicker()}
                        {openOnlyCheckbox()}
                        {buttons()}
                    </div>
                </div>
            </div>
        </Modal>
    </>;
}